import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '17bb1478b3786cec785b45aef73c2fc8.png',
	fr: 'bcb5f97682b168d583fba047b00d1286.png',
};

export const LyricsClick: FunctionComponent = () => {
	const {t} = useTranslation();
	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			description={
				<>
					<LandingHeading as="h2">
						{t(
							'lyricslandingpage_title_songlyricsonlyoneclickaway_standalone-web',
							{ns: 'lyrics'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'lyricslandingpage_text_songlyricsonlyoneclickaway_standalone-web',
							{ns: 'lyrics'},
						)}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					objectFit="cover"
					aspectRatio="2880/840"
					h={{base: '250px', md: '100%'}}
					src={src}
					alt={t('metatag_text_songlyrics_standalone-web', {ns: 'common'})}
				/>
			}
		/>
	);
};
